<template>
    <el-drawer
        title="批量隐藏"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="appHideType" label="APP:">
                    <el-radio-group v-model="formData.appHideType" size="medium">
                        <el-radio :label="0">正常展示</el-radio>
                        <el-radio :label="1">列表隐藏</el-radio>
                        <el-radio :label="2">列表和详情页隐藏</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="wapHideType" label="WAPCN:">
                    <el-radio-group v-model="formData.wapHideType" size="medium">
                        <el-radio :label="0">正常展示</el-radio>
                        <el-radio :label="1">列表隐藏</el-radio>
                        <el-radio :label="2">列表和详情页隐藏</el-radio>
                    </el-radio-group>
                </el-form-item>
				<el-form-item prop="byteHideType" label="抖音小程序:">
				    <el-radio-group v-model="formData.byteHideType" size="medium">
				        <el-radio :label="0">正常展示</el-radio>
				        <el-radio :label="1">列表隐藏</el-radio>
				        <el-radio :label="2">列表和详情页隐藏</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="wxHideType" label="微信小程序:">
				    <el-radio-group v-model="formData.wxHideType" size="medium">
				        <el-radio :label="0">正常展示</el-radio>
				        <el-radio :label="1">列表隐藏</el-radio>
				        <el-radio :label="2">列表和详情页隐藏</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="aliHideType" label="支付宝小程序:">
				    <el-radio-group v-model="formData.aliHideType" size="medium">
				        <el-radio :label="0">正常展示</el-radio>
				        <el-radio :label="1">列表隐藏</el-radio>
				        <el-radio :label="2">列表和详情页隐藏</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="redHideType" label="小红书小程序:">
				    <el-radio-group v-model="formData.redHideType" size="medium">
				        <el-radio :label="0">正常展示</el-radio>
				        <el-radio :label="1">列表隐藏</el-radio>
				        <el-radio :label="2">列表和详情页隐藏</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="webHideType" label="WEB:">
				    <el-radio-group v-model="formData.webHideType" size="medium">
				        <el-radio :label="0">正常展示</el-radio>
				        <el-radio :label="1">列表隐藏</el-radio>
				        <el-radio :label="2">列表和详情页隐藏</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="meiTuanHideType" label="美团小程序:">
				    <el-radio-group v-model="formData.meiTuanHideType" size="medium">
				        <el-radio :label="0">正常展示</el-radio>
				        <el-radio :label="1">列表隐藏</el-radio>
				        <el-radio :label="2">列表和详情页隐藏</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="taiYouthHideType" label="太校园小程序:">
				    <el-radio-group v-model="formData.taiYouthHideType" size="medium">
				        <el-radio :label="0">正常展示</el-radio>
				        <el-radio :label="1">列表隐藏</el-radio>
				        <el-radio :label="2">列表和详情页隐藏</el-radio>
				    </el-radio-group>
				</el-form-item>
            </el-form> 
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">提交</el-button>
        </div>
    </el-drawer>
</template>

<script>

const defaultFormData = {
    activityIdList: [],
    appHideType: 0,
    webHideType: 0,
	aliHideType: 0,
	wxHideType: 0,
	byteHideType:0,
	redHideType:0,
	wapHideType:0,
	meiTuanHideType:0,
	taiYouthHideType:0
}
export default {
    props:{
        activityIds:{
            type:Array,
            default: () => []
        }
    },
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultFormData
            },
            rules: {
                
            },
        }
    },
    methods:{
        close() {
            this.formData = {...defaultFormData};
            // this.$refs.formData.resetFields();
            this.$refs.formData.clearValidate();
            this.drawerShow = false;
        },
        show(data) {
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.$request({
                        url: '/activity/batchHideActivity',
                        data: {
                            ...this.formData,
                            activityIdList: this.activityIds
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, errmsg } = res.data;
                            if (state) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(errmsg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>